'use client';

import { useCounter } from '@/hooks/use-counter';
import { cn } from '@/lib/utils';

/**
 * Single animated proof stat. Counts up from 0 on first viewport entry.
 * The ref from useCounter is attached to the value <span> — this is the DOM
 * node that IntersectionObserver watches. Keeping the ref on the visible
 * number (not a wrapper div) ensures the observer fires when the digit
 * is actually in view.
 */
export function ProofStat({
  value,
  label,
  valueClassName,
  labelClassName,
}: {
  value: string;
  label: string;
  /** Optional className for the animated value span. Defaults to mono tabular style. */
  valueClassName?: string;
  /** Optional className for the label span. */
  labelClassName?: string;
}) {
  const [ref, display] = useCounter(value);

  return (
    <>
      <span
        ref={ref}
        className={cn(
          'font-mono tnum text-(--color-text)',
          valueClassName,
        )}
      >
        {display}
      </span>
      <span
        className={cn(
          'text-[11px] uppercase tracking-wider text-(--color-text-subtle)',
          labelClassName,
        )}
      >
        {label}
      </span>
    </>
  );
}
